import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Upload,
  notification,
  Space,
  Table,
  Popconfirm,
  Tag,
  Alert,
  Spin
} from "antd";
import {
  UploadOutlined,
  FileExcelOutlined,
  SaveOutlined,
  SearchOutlined,
  ReloadOutlined,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { ExcelRenderer } from "react-excel-renderer";
import ReactExport from "react-export-excel";

//api
import util from "helpers/util";
import apiStockAdjustment from "constants/api/stockAdjustment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function CreateAdjustment({ onDone, draftNumberEdit }) {

  const [btnDraftLoading, setBtnSubmitLoading] = useState(false);
  const [btnDraftDisabled, setBtnSubmitDisabled] = useState(false);
  const [dataSetExcel, setDataSetExcel] = useState([]);

  const [isLoadingTab1, setIsLoadingTabCreateAdjustment] = useState(false);

  const [isLoadingTbStockAdjustment, setIsLoadingTbCreateAdjustment] = useState(false);

  //store
  const [selectedRowKeysStockAdjustment, setSelectedRowKeysStockAdjustment] = useState([]);

  const [rowsStockAdjustmentExcel, setRowsStockAdjustmentExcel] = useState([]);

  const [tbStoreSearchText, setTbStoreSearchText] = useState("");
  const [tbStoreSearchedColumn, setTbStoreSearchedColumn] = useState("");
  const tbStoreSearchInput = useRef(null);

  //brands
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [draftNumberTemp, setDraftNumberTemp] = useState("");

  const validStatusTable = "Valid";

  const handleDeleteStockAdjustment = (key) => {
    const rows = rowsStockAdjustmentExcel;
    setRowsStockAdjustmentExcel(rows.filter((item) => item.key !== key));
  };

  const [visible, setIsVisible] = useState("none");
  const [successLine, setSuccessLine] = useState(0);
  const [errorLine, setErrorLine] = useState(0);

  useEffect(() => {
    if (draftNumberEdit != null) {
      const existData = [];
      apiStockAdjustment
        .getDraftDetail(draftNumberEdit)
        .then((res) => {
          //setStores(res);

          if (res.success) {
            res.result.details.map((row, index) => {
              existData.push({
                key: index + 1,
                supplierBarcode: row.supplierBarcode,
                qty: row.qty,
                status: row.status
              });
            });

            setSelectedStores(res.result.stores);
            setRowsStockAdjustmentExcel(existData);
            form.setFieldsValue({ store: res.result.stores });
            setIsEdit(true);
            setDraftNumberTemp(draftNumberEdit);

            onDone();
            //draftNumberEdit = null;
          }
          else {
            notification.error({
              message: "Error",
              description: "Failed to get draft data",
              duration: 0,
            });

            setSelectedStores([]);
            setRowsStockAdjustmentExcel([]);
            form.setFieldsValue({ store: [] });
            setIsEdit(false);
            setDraftNumberTemp("");

            onDone();
          }
        })
        .catch((err) => {
          util.displayApiError(err);
        })
    }
  }, [draftNumberEdit])

  useEffect(() => {
    //setIsLoadingTbOL(true);
    apiStockAdjustment
      .getListStores()
      .then((res) => {
        setStores(res);
      })
      .catch((err) => {
        util.displayApiError(err);
      })
    //.finally(() => setIsLoadingTbOL(false));
  }, []);

  //Store
  const tbStockAdjustmentGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStoreSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStoreHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStoreSearchText(selectedKeys[0]);
              setTbStoreSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        // setTimeout(() => tbStoreSearchInput.select(), 100);
      }
    },
    // eslint-disable-next-line react/display-name
    render: (text) =>
      tbStoreSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbStoreSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const tbStoreHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStoreSearchText(selectedKeys[0]);
    setTbStoreSearchedColumn(dataIndex);
  };

  const tbStoreHandleReset = (clearFilters) => {
    clearFilters();
    setTbStoreSearchText("");
  };

  const columnsStockAdjustment = [
    {
      title: "Supplier Barcode",
      //width:300,
      dataIndex: "supplierBarcode",
      ...tbStockAdjustmentGetColumnSearchProps("supplierBarcode"),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      sorter: (a, b) => a.qty - b.qty,
      ...tbStockAdjustmentGetColumnSearchProps("qty"),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      ...tbStockAdjustmentGetColumnSearchProps("status"),
      // render: (text, record) =>
      //   text === "OK" ? (
      //     <Tag color="success">OK</Tag>
      //   ) : text === "Invalid store id" ? (
      //     <Tag color="error">Invalid <br />
      //     store ID</Tag>
      //   ) : (
      //     <Tag color="error">Close</Tag>
      //   ),
      render: (text, record) =>
        text === validStatusTable ? (
          <Tag color="success">{text}</Tag>
        ) : text === "Qty < 0" ? (
          <Tag color="error">Qty must <br /> greater <br /> than zero</Tag>
        ) : (
          <Tag color="error">{text}</Tag>
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) =>
        rowsStockAdjustmentExcel.length >= 1 ? (
          <Popconfirm
            title="Sure to remove?"
            onConfirm={() => handleDeleteStockAdjustment(record.key)}
          >
            <CloseCircleTwoTone twoToneColor="#f50" />
            &nbsp;Remove
          </Popconfirm>
        ) : null,
    }
  ];

  const fileHandlerStore = (fileList) => {
    setIsLoadingTbCreateAdjustment(true);
    let fileObj = fileList;
    if (!fileObj) {
      notification.error({
        message: "No file uploaded",
        duration: 0,
      });

      //setErrorMessageStore("No file uploaded!");
      setIsLoadingTbCreateAdjustment(false);
      return false;
    }
    if (
      !(
        fileObj.type === "application/vnd.ms-excel" ||
        fileObj.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
    ) {
      notification.error({
        message: "Error",
        description: "Unknown file format. Only Excel files are uploaded",
        duration: 0,
      });

      setRowsStockAdjustmentExcel([]);
      setIsLoadingTbCreateAdjustment(false);
      return false;
    }
    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        util.displayApiError(err);
      } else {
        // let param = {
        //   stores: selectedStores,
        //   details: []
        // };
        let param = [];
        console.log(resp.rows);
        let newRows = [];
        let isExcelValid = true;
        //let newDetails = []
        //let originalStoreExcel = [];

        resp.rows.slice(0, 1).map((row, index) => {
          if (row && row !== "undefined") {
            if (row[0].toLowerCase() !== "supplierbarcode") {
              isExcelValid = false;
            }
            else if (row[1].toLowerCase() !== "qty") {
              isExcelValid = false;
            }
          }
        });

        if (!isExcelValid) {
          notification.error({
            message: "Error",
            description: "Failed to process excel",
            duration: 0,
          });

          setRowsStockAdjustmentExcel([]);
          setIsLoadingTbCreateAdjustment(false);
          return false;
        }

        resp.rows.slice(1).map((row, index) => {
          if (row && row !== "undefined") {
            if (row[0] || row[1]) {
              param.push({
                key: index + 1,
                supplierBarcode: row[0] != null ? row[0].toString() : "",
                qty: row[1],
                status: ""
              });
              // originalStoreExcel.push({
              //   storeId: row[0].toString(),
              //   storeName: row[1]
              // });
            }
          }
        });

        if (param.length === 0) {
          notification.error({
            message: "Error",
            description: "No valid data found in file!",
            duration: 0,
          });

          setRowsStockAdjustmentExcel([]);
          setIsLoadingTbCreateAdjustment(false);
          return false;
        } else {
          apiStockAdjustment
            .processAdjustExcel(param)
            .then((res) => {
              if (res == null) {
                notification.error({
                  message: "Error",
                  description: "Failed to process excel",
                  duration: 0,
                });

                setIsLoadingTbCreateAdjustment(false);
                return;
              }

              res.map((row, index) => {
                newRows.push({
                  key: index + 1,
                  supplierBarcode: row.supplierBarcode,
                  qty: row.qty,
                  status: row.status
                });
                if (row.status === "Valid") {
                  setSuccessLine(successLine + 1);
                } else {
                  setErrorLine(errorLine + 1);
                }
              });
              setRowsStockAdjustmentExcel(newRows);
              setSelectedRowKeysStockAdjustment(newRows.map((item) => item.key));
              setIsLoadingTbCreateAdjustment(false);
              setIsVisible("");
            })
            .catch((err) => {
              util.displayApiError(err);
              setIsLoadingTbCreateAdjustment(false);
            });
        }
      }
    });
    return false;
  };

  const [form] = Form.useForm();
  //const dateFormat = "YYYY-MM-DD";

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.filelist;
  };

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeysStockAdjustment(selectedRowKeys);
  };

  //FINISH
  const onFormFinish = (values) => {
    setBtnSubmitLoading(true);
    setIsLoadingTabCreateAdjustment(true);

    if (rowsStockAdjustmentExcel.length === 0) {
      notification.warning({
        message: "Warning",
        description: "No stock adjustment data",
      });

      setBtnSubmitLoading(false);
      setIsLoadingTabCreateAdjustment(false);
      return;
    }

    const selectedStockAdjustment = rowsStockAdjustmentExcel.filter(data => selectedRowKeysStockAdjustment.includes(data.key));

    if (selectedStockAdjustment.length == 0) {
      notification.warning({
        message: "Warning",
        description: "No data selected, please tick minimum one data on table",
      });
      setBtnSubmitLoading(false);
      setIsLoadingTabCreateAdjustment(false);

      return;
    }

    const nonValidStockAdjustment = selectedStockAdjustment.filter(({ status }) => status != validStatusTable);

    if (nonValidStockAdjustment.length > 0) {
      notification.warning({
        message: "Warning",
        description: `Please delete data with non ${validStatusTable.toLowerCase()} status`,
      });
      setBtnSubmitLoading(false);
      setIsLoadingTabCreateAdjustment(false);

      return;
    }

    const dataForSubmit = {
      draftNumber: draftNumberTemp,
      stores: selectedStores,
      details: selectedStockAdjustment
    };

    if (!isEdit) {
      apiStockAdjustment
        .uploadDraft(dataForSubmit)
        .then((res) => {
          if (res.success) {
            setBtnSubmitLoading(false);
            setIsLoadingTabCreateAdjustment(false);
            resetForm();

            notification.success({
              message: "Success",
              description: res.message,
              duration: 0,
            });

            setBtnSubmitDisabled(false);
          } else {
            notification.error({
              message: "Failed",
              description: res.message,
              duration: 0,
            });

            setBtnSubmitLoading(false);
            setIsLoadingTabCreateAdjustment(false);
          }
        })
        .catch((err) => {
          notification.error({
            message: "Internal server error. please contact administrator",
            duration: 0,
          });
          setBtnSubmitLoading(false);
          setIsLoadingTabCreateAdjustment(false);
        });
    }
    else {
      apiStockAdjustment
        .updateDraft(dataForSubmit)
        .then((res) => {
          if (res.success) {
            setBtnSubmitLoading(false);
            setIsLoadingTabCreateAdjustment(false);
            resetForm();

            notification.success({
              message: "Success",
              description: res.message,
              duration: 0,
            });

            setBtnSubmitDisabled(false);
            setIsEdit(false);
            setDraftNumberTemp("");
          } else {
            notification.error({
              message: "Failed",
              description: res.message,
              duration: 0,
            });

            setBtnSubmitLoading(false);
            setIsLoadingTabCreateAdjustment(false);
            setIsEdit(false);
            setDraftNumberTemp("");
          }
        })
        .catch((err) => {
          notification.error({
            message: "Internal server error. please contact administrator",
            duration: 0,
          });
          setBtnSubmitLoading(false);
          setIsLoadingTabCreateAdjustment(false);
        });
    }
  };

  const resetForm = () => {
    form.resetFields();
    setRowsStockAdjustmentExcel([]);
    setBtnSubmitDisabled(false);
    setSelectedStores([]);
    setIsEdit(false);
    setDraftNumberTemp("");
    setIsVisible("none");
  };

  return (
    <>
      <Spin tip="Submitting..." size="large" spinning={isLoadingTab1}>
        <Form
          layout="vertical"
          form={form}
          size="middle"
          style={{ paddingLeft: 16, paddingRight: 16 }}
          onFinish={onFormFinish}
        >
          <br />
          <Row gutter={16}>
            <Col
              span={12}
              style={{
                backgroundColor: "#DDF7F9",
                padding: 4,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Space direction="vertical" size={0}>
                <Form.Item
                  name="store"
                  label="Store:"
                >
                  {
                    (selectedStores.length) ? (
                      <Select
                        key="storesDropdown"
                        //key={selectedStores}
                        //value={selectKey}
                        mode="multiple"
                        size="middle"
                        placeholder="All stores selected"
                        maxTagCount="responsive"
                        value={selectedStores}
                        allowClear
                        filterOption={(input, option) =>
                          option.key.toLowerCase().includes(input.toLowerCase()) ||
                          String(option.value)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onSelect={(value) => {
                          setSelectedStores([...selectedStores, value]);
                        }}
                        onDeselect={(value) => {
                          setSelectedStores(
                            selectedStores.filter(
                              (oldValues) => oldValues !== value
                            )
                          );
                        }}
                        onClear={() => setSelectedStores([])}
                        style={{ width: 400, fontSize: 12, textAlign: "start" }}
                      >
                        {stores.map((store) => {
                          return (
                            <Select.Option
                              key={store.storeName}
                              title={`Store ID: ${store.storeId}`}
                              value={store.storeId}
                              style={{ fontSize: 12 }}
                              selected
                            >
                              {store.storeId}-{store.storeName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    ) : (
                      <Select
                        key="storesDropdown"
                        mode="multiple"
                        size="middle"
                        placeholder="All stores selected"
                        maxTagCount="responsive"
                        allowClear
                        filterOption={(input, option) =>
                          option.key.toLowerCase().includes(input.toLowerCase()) ||
                          String(option.value)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onSelect={(value) => {
                          setSelectedStores([...selectedStores, value]);
                        }}
                        onDeselect={(value) => {
                          setSelectedStores(
                            selectedStores.filter(
                              (oldValues) => oldValues !== value
                            )
                          );
                        }}
                        onClear={() => setSelectedStores([])}
                        style={{ width: 400, fontSize: 12, textAlign: "start" }}
                      >
                        {stores.map((store) => {
                          return (
                            <Select.Option
                              key={store.storeName}
                              title={`Store ID: ${store.storeId}`}
                              value={store.storeId}
                              style={{ fontSize: 12 }}
                            >
                              {store.storeId}-{store.storeName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    )
                  }

                </Form.Item>
                <Form.Item
                  name="radio-group"
                  label="Upload :"
                  rules={[
                    {
                      required: (isEdit ? false : true),
                      message: "Data is required",
                    },
                  ]}
                  red
                >
                  <Space align="start">
                    <ExcelFile
                      element={
                        <Button icon={<FileExcelOutlined />}>
                          Sample File
                        </Button>
                      }
                      filename="Sample Stock Adjustment"
                    >
                      <ExcelSheet data={dataSetExcel} name="Sheet1">
                        <ExcelColumn label="SupplierBarcode" value="supplierBarcode" />
                        <ExcelColumn label="Qty" value="qty" />
                      </ExcelSheet>
                    </ExcelFile>
                    <Form.Item
                      name="uploadItem"
                      valuePropName="filelist"
                      getValueFromEvent={normFile}
                      extra=""
                    >
                      <Upload
                        name="file"
                        beforeUpload={fileHandlerStore}
                        onRemove={() => setRowsStockAdjustmentExcel([])}
                        multiple={false}
                        maxCount={1}
                      >
                        <Button type="primary" icon={<UploadOutlined />}>
                          Upload XLSX
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Space>
                </Form.Item>
              </Space>
            </Col>
            <Col
              span={12}
              style={{ backgroundColor: "#DDF7F9", padding: 4 }}
            >
              <Table
                loading={isLoadingTbStockAdjustment}
                size="small"
                columns={columnsStockAdjustment}
                rowSelection={{
                  selectedRowKeys: selectedRowKeysStockAdjustment,
                  onChange: onSelectChange,
                }}
                dataSource={rowsStockAdjustmentExcel}
                // pagination={{ pageSize: 5 }}
                pagination={false}
                scroll={{ y: 200 }}
                bordered
              />
              <div style={{ display: "flex" }}>
                <Alert
                  message={`Total data: ${rowsStockAdjustmentExcel.length} row(s)`}
                  type="info"
                  showIcon
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0em 0.8em 0em 0.8em"
                  }}
                >
                  <h4>
                    {`Success : ${rowsStockAdjustmentExcel.filter((item) => item.status === "Valid").length} rows(s) | Failed: ${rowsStockAdjustmentExcel.filter((item) => item.status !== "Valid").length} row(s)`}
                  </h4>
                </div>
                <ExcelFile
                  element={
                    <Button icon={<FileExcelOutlined />} style={{ marginLeft: "0.8em", height: "2.75em", display: visible }}>
                      Failed Data
                    </Button>
                  }
                  filename="Failed Stock Adjustment draft"
                >
                  <ExcelSheet data={rowsStockAdjustmentExcel.filter((item) => item.status !== "Valid")} name="Sheet1">
                    <ExcelColumn label="Supplier Barcode" value="supplierBarcode" />
                    <ExcelColumn label="Qty" value="qty" />
                    <ExcelColumn label="Status" value="status" />
                  </ExcelSheet>
                </ExcelFile>
              </div>
            </Col>
          </Row>

          <br />

          <Form.Item>
            <Space>
              <Button
                icon={<SaveOutlined />}
                size="large"
                type="primary"
                htmlType="submit"
                loading={btnDraftLoading}
                disabled={btnDraftDisabled}
              >
                Draft
              </Button>
              <Button
                icon={<ReloadOutlined />}
                size="large"
                onClick={resetForm}
              >
                Reset Form
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </>
  );
}
